import React, { useContext, useEffect, useRef } from 'react'
import { AuthContext } from '../context/AuthContext'
import { ChatContext } from '../context/ChatContext'

const Chat = ({message}) => {
  const {currentuser} = useContext(AuthContext)
  // Chat user
  const {data} = useContext(ChatContext)

  const ref = useRef();

  useEffect(()=>{
    ref.current?.scrollIntoView({behaviour:"smooth"})
  },[message])
  return (
    <div className={`conv-message ${message.senderId === currentuser.uid && "owner"}`} ref={ref}>
     <div className="msginfo">
        <img src={
          message.senderId == currentuser.uid ? currentuser.photoURL : data.user.photoURL
        } />
     </div>
     <div className={`conv-message msgcontent  ${message.senderId === currentuser.uid && "owner"}`}>
        {message.text && <p>{message.text}</p> }
        {message.img && <img 
        src={message.img} 
        />}
      
     </div>
    </div>
  )
}

export default Chat